{
  "roles": "Roles",
  "title": "Roles",
  "description": "Define custom roles and choose the permissions granted to each one.",
  "addNew": "Create Role",
  "searchPlaceholder": "Search roles...",
  "noResultsTitle": "No Results Found",
  "noResultsMessage": "The filters selected returned no results.",
  "noDataTitle": "No Roles Created Yet",
  "noDataMessage": "Click “Create Role” above to define your first custom role.",
  "backToList": "Back to Roles",
  "deleteModalTitle": "Are you sure you want to delete the <strong>{{name}}</strong> role?",
  "table": {
    "name": "Name",
    "permissions": "Permissions",
    "actions": "Actions",
    "users": "Users",
    "noUsers": "No users have this role.",
    "toggleUsers": "Toggle the user list for {{name}}",
    "systemRole": "System role",
    "systemTag": "System",
    "accessScopesTag": "Access Scopes",
    "permissionCount": "{{count}} permission",
    "permissionCount_plural": "{{count}} permissions"
  },
  "form": {
    "createTitle": "Create Role",
    "editTitle": "Edit Role",
    "viewTitle": "View Role",
    "systemRoleMessage": "This is a system-defined role and is view only. System roles cannot be modified.",
    "readOnlyMessage": "You don't have the required permissions to edit roles, so this role is view only.",
    "description": "Give the role a name and select the permissions and/or the access scopes it should grant.",
    "nameLabel": "Role Name",
    "namePlaceholder": "Name your role",
    "nameRequired": "Role name is required.",
    "parentRoleLabel": "Select a parent role to inherit or clone permissions from <i class='text-muted'> (optional)</i>",
    "parentRolePlaceholder": "Select a parent role",
    "inheritMode": "Inherit",
    "cloneMode": "Clone",
    "inheritHelp": "Inheriting keeps this role linked to the parent. Permissions are additive, and any permissions later added to the parent role are automatically inherited.",
    "cloneHelp": "Cloning copies the selected permissions as a starting point and detaches the parent. The role will only have the permissions you set here and will not inherit future changes from the parent.",
    "permissionsLabel": "Permissions",
    "permissionsRequired": "Select at least one permission.",
    "permissionsOrScopeRequired": "Select at least one permission or add an access scope.",
    "permissionsEmpty": "No permissions are available.",
    "tabs": {
      "permissions": "Permissions",
      "accessScopes": "Access Scopes"
    },
    "accessScopes": {
      "description": "Define the Log Analysis queries a user with this role can run in live tail. Leave empty to grant access to everything.",
      "label": "Access Scope",
      "queryPlaceholder": "Query",
      "addQuery": "Add query",
      "removeQuery": "Remove {{query}} query",
      "preview": "Preview"
    },
    "searchPermissions": "Search permissions...",
    "collectingPermissions": "Collecting parent permissions...",
    "permissionName": "Permission",
    "inheritedPermission": "Granted by the parent role and cannot be changed.",
    "inheritedMinimum": "The parent role grants at least this level. You can raise it but not lower it.",
    "unavailablePermission": "You can only grant permissions you currently have.",
    "inheritedRoleWarning": "The role {{roles}} currently inherits from this role. Therefore this role cannot be deleted.",
    "inheritedRoleWarning_plural": "The roles {{roles}} currently inherit from this role. Therefore this role cannot be deleted.",
    "none": "None",
    "read": "Read",
    "write": "Write",
    "manage": "Manage"
  }
}
